import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StartingScreen from './components/StartingScreen';
import ChatScreen from './components/ChatScreen';
import './App.css';

function App() {
  return (
    <Router>
      <div className='App'>
        <Routes>
          <Route path='/' element={<StartingScreen />} />
          <Route path='/chat' element={<ChatScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


